module.exports = __webpack_public_path__ + "static/img/56969_0_dzieci na plazy_original127.0c478f1d.png";